import { getPathNameFromWindow } from '@src/quince-site-common/src/utils/getPathName'

import { TELEMETRY_DOMAINS } from '../telemetry-domains.constants'
import { TELEMETRY_EVENT_NAMES } from '../telemetry-events.constants'

const generateNumericCachebuster = () => {
  const array = new Uint32Array(2)
  self.crypto.getRandomValues(array)
  return `${array[0]}${array[1]}`
}

export const transformUrl = (url: string): string => {
  const trimmedUrl = url.trim().replace(/(^\/|\/$)/g, '')

  if (trimmedUrl === '') {
    return 'home_page'
  }

  return trimmedUrl
}

export const Poplar = {
  config: {
    enabled: true,
    eventIdealTimeout: 1000,
    domain: TELEMETRY_DOMAINS.POPLAR,
  },

  events: {
    [TELEMETRY_EVENT_NAMES.PAGE_VIEW]: () => {
      /**
       * The tracking is handled by loading a script on each page visit.
       * Normally, we load scripts on gatsby browser, but it only includes and exports the script once.
       * For these, we need to re-run those scripts on each view
       * And hence we first remove the existing script and re-load a new one.
       * The config had 'id' in attributes, which takes care of removing before inserting a new one.
       */
      for (const iframe of document.getElementsByTagName('iframe')) {
        if (iframe.id === 'quince-poplarpixel') {
          iframe.remove()
        }
      }

      const cachebuster = generateNumericCachebuster()
      const currentPage = getPathNameFromWindow()

      const customDimension = transformUrl(currentPage ?? '')
      const iframeUrl = `${TELEMETRY_DOMAINS.POPLAR}/iframe/12648/?che=${cachebuster}&cd1=quince635c&cd2=${customDimension}`

      // Create and insert the iframe
      const iframe = document.createElement('iframe')
      iframe.setAttribute('width', '1')
      iframe.setAttribute('height', '1')
      iframe.setAttribute('frameBorder', '0')
      iframe.setAttribute('style', 'display: none;')
      iframe.setAttribute('id', 'quince-poplarpixel')
      iframe.src = iframeUrl
      document.body.appendChild(iframe)
    },
  },
}
